export default "__VITE_ASSET__DVmum_i5__"